import { render, staticRenderFns } from "./aufgabe_abgelehnt.vue?vue&type=template&id=0dd1b73a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./aufgabe_abgelehnt.vue?vue&type=script&lang=js"
export * from "./aufgabe_abgelehnt.vue?vue&type=script&lang=js"
import style0 from "./aufgabe_abgelehnt.vue?vue&type=style&index=0&id=0dd1b73a&prod&lang=css"
import style1 from "./aufgabe_abgelehnt.vue?vue&type=style&index=1&id=0dd1b73a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1b73a",
  null
  
)

export default component.exports